import IFrameExplanation from './IFrameExplanation'

export default IFrameExplanation
